import React from "react";
import {
  Card,
  CardContent,
  Stack,
  Box,
  Typography,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  getTableConfig,
  STATUS_COLOR_MAP,
  FIELD_EXTRACTORS,
  TABLE_TYPES,
} from "../config/tableConfig";
import { Add } from "@mui/icons-material";

const BADGE_TINTS = {
  success: { bg: "#EAFBF2", color: "#0C7A45" },
  error: { bg: "#FDECEC", color: "#B3261E" },
  warning: { bg: "#FEF6E7", color: "#95660A" },
  default: { bg: "#F1F3F2", color: "#5C6864" },
};

const getBadgeTint = (colorKey) => BADGE_TINTS[colorKey] || BADGE_TINTS.default;

const MobileView = ({ tableType, data, dialogs, isFetching, onMenuOpen }) => {
  const config = getTableConfig(tableType);

  const getCellValue = (item, columnId) => {
    if (FIELD_EXTRACTORS[columnId]) {
      return FIELD_EXTRACTORS[columnId](item, tableType);
    }

    const value = item[columnId];

    return value || "--";
  };

  const getStatusColor = (status) => {
    return STATUS_COLOR_MAP[status] || "default";
  };

  const primaryField = config.dataField;

  const displayColumns = config.columns.filter((col) => col.id !== "action");

  return (
    <Stack spacing={1.5} sx={{ mb: 3, opacity: isFetching ? 0.6 : 1 }}>
      {data.map((item) => {
        const tint = getBadgeTint(getStatusColor(getCellValue(item, "status")));
        return (
          <Card
            key={item.id}
            sx={{
              borderRadius: 3,
              border: "1px solid #E6ECEA",
              boxShadow: "0 1px 2px rgba(16,24,22,0.04)",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 1.5,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 650,
                      fontSize: 15,
                      mb: 1,
                      color: "#12181A",
                    }}
                  >
                    {getCellValue(item, primaryField)}
                  </Typography>
                  <Chip
                    label={getCellValue(item, "status")}
                    size="small"
                    sx={{
                      backgroundColor: tint.bg,
                      color: tint.color,
                      fontWeight: 650,
                      fontSize: 12,
                      border: "none",
                    }}
                  />
                </Box>
                {tableType === TABLE_TYPES.PRE_ONBOARDING ||
                tableType === TABLE_TYPES.LEADS ? (
                  <IconButton
                    size="small"
                    onClick={(e) => onMenuOpen(e, item)}
                    sx={{
                      color: "#66766F",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#E6F5F2",
                        color: "#0B5F56",
                      },
                    }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                ) : (
                  <Button
                    size="small"
                    disabled={
                      item.status === "Completed" || item.status === "completed"
                    }
                    onClick={() => {
                      dialogs.rowActions.handleCardAddition(item);
                    }}
                    sx={{
                      padding: 0.5,
                      px: 1.5,
                      minHeight: 25,
                      borderRadius: 5,
                      backgroundColor: "#E6F5F2",
                      color: "#0B5F56",
                      boxShadow: "none",
                      fontWeight: 650,
                      "&:hover": {
                        backgroundColor: "#0E7A6E",
                        color: "#fff",
                        boxShadow: "none",
                      },
                    }}
                    startIcon={<Add />}
                  >
                    Card
                  </Button>
                )}
              </Box>

              <Box sx={{ borderTop: "1px solid #E6ECEA", pt: 1.5 }}>
                <Stack spacing={1.25}>
                  {displayColumns
                    .filter(
                      (col) =>
                        col.id !== primaryField &&
                        col.id !== "status" &&
                        col.id !== "date",
                    )
                    .map((column) => {
                      return (
                        <Box
                          key={column.id}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#98A6A0",
                              fontWeight: 650,
                              fontSize: 11,
                              textTransform: "uppercase",
                              letterSpacing: "0.03em",
                            }}
                          >
                            {column.label}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 550, color: "#3A4441" }}
                          >
                            {getCellValue(item, column.id)}
                          </Typography>
                        </Box>
                      );
                    })}
                </Stack>
              </Box>
            </CardContent>
          </Card>
        );
      })}
    </Stack>
  );
};

export default MobileView;
